import React from "react";
import "./styles.css";

export default function AppText({ children, weight, size = "_18", color, align = "_left" }) {
  return <p className={`app-text ${weight} ${size} ${color} ${align}`}>{children}</p>;
}
